import constant from "@/config/constant";
import React from "react";

// Mui Styles
import { StyledPaper } from "@/styles/mui/globalStyles";
import { ThemeProvider } from "@mui/material/styles";

import { AddOutlined } from "@mui/icons-material";
import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid2";
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";

import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";

//lodash
import _ from "lodash";

// CSS
import "@/styles/page/employeeShopping.css";
import "@/styles/page/systemSettingProductPage.css";

// Navigate
import { useNavigate, useParams } from "react-router-dom";

// Components
import Layout from "@/components/layout";
import Title from "@/components/title";
import { getAllPromoter } from "@/fetch/fetchStaff";
import { UpperForm } from "./questionnaireCreatePage";

// Mui Icon
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";

// Fetch
import {
  getQuestionnarieSetting,
  updateQuestionnarieSettings,
} from "@/fetch/fetchQuestionnarie";

// Moment
import { FormHelperText } from "@mui/material";
import Moment from "moment";
import { extendMoment } from "moment-range";
import "moment/locale/zh-hk";

const QuestionnaireUpdatePage = (props) => {
  const { open, setOpen } = props;
  const moment = extendMoment(Moment);
  const { questId } = useParams();

  // Navigate
  const navigate = useNavigate();

  // States
  const [snackSeverity, setSnackSeverity] = React.useState("success");
  const [snackMessage, setSnackMessage] = React.useState("");
  const [snackOpen, setSnackOpen] = React.useState(false);
  const [optionList, setOptionList] = React.useState([]);
  const [formGroup, setFormGroup] = React.useState([
    {
      type: constant.boxValue[0].type,
      labelName: "",
      optionValue: Array(2).fill({ value: "", label: "" }),
    },
  ]);
  const [isErrorFormDetail, setIsErrorFormDetail] = React.useState({
    title: "",
    promoter: "",
  });
  const [isErrorFormGroup, setIsErrorFormGroup] = React.useState([
    { type: "", labelName: "", optionValue: "" },
  ]);
  const [formDetail, setFormDetail] = React.useState({
    title: "",
    promoter: [],
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().endOf("month").format("YYYY-MM-DD"),
  });
  const formGroupCopy = [...formGroup];

  // Fetch
  const fetchAll = async () => {
    try {
      const { data: promoter } = await getAllPromoter();
      const { data: questionData } = await getQuestionnarieSetting(
        questId ?? 0
      );

      setOptionList(promoter);

      if (!_.isEmpty(questionData)) {
        const { title, promoter, start_date, end_date } = questionData;
        setFormDetail({
          title,
          promoter: promoter,
          startDate: moment(start_date).format("YYYY-MM-DD"),
          endDate: moment(end_date).format("YYYY-MM-DD"),
        });
        setFormGroup(questionData.field_value);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmit = async () => {
    const newFormGroup = {
      questId: questId,
      ...formDetail,
      promoter: formDetail.promoter,
      field_value: formGroup,
    };

    const isErrorFormDetail = {
      title: formDetail.title ? "" : "不能為空值",
      promoter: formDetail.promoter.length > 0 ? "" : "不能為空值",
    };

    const isErrorFormDetailSet = Object.values(isErrorFormDetail).some(
      (item) => item && true
    );

    const isErrorFormGroup = newFormGroup.field_value.map((item) => {
      const optionValue =
        item.type !== "uploadFile" &&
        item.type !== "textField" &&
        item.type !== "please select" &&
        item.type !== "dropDownWithProduct"
          ? item.optionValue.map((option) => ({
              label: option.label ? "" : "不能為空值",
              value: option.value ? "" : "不能為空值",
            }))
          : item.optionValue.map(() => ({
              label: "",
              value: "",
            }));
      return {
        type: item.type !== "please select" ? "" : "不能為空值",
        labelName: item.labelName ? "" : "不能為空值",
        optionValue,
      };
    });

    const isErrorFormGroupSet = isErrorFormGroup.some((item) => {
      const optionValue = item.optionValue.some((option) => {
        return Object.values(option).some((innerOption) => innerOption && true);
      });
      if (item.type || item.labelName || optionValue) return true;
    });

    if (isErrorFormDetailSet) {
      setIsErrorFormDetail(isErrorFormDetail);
      return false;
    }

    if (isErrorFormGroupSet) {
      setIsErrorFormGroup(isErrorFormGroup);
      return false;
    }

    try {
      const { data } = await updateQuestionnarieSettings(newFormGroup);
      if (data.id) {
        setSnackMessage("已修改");
        setSnackSeverity("success");
      } else {
        setSnackMessage("新增失敗");
        setSnackSeverity("error");
      }
    } catch (err) {
      console.log(err);
    } finally {
      setSnackOpen(true);
      fetchAll();
      setTimeout(() => navigate("/questionnaireConfig"), 500);
    }
  };

  // Browser Back
  const handleBeforeUnload = (e) => {
    e.preventDefault();
    const message =
      "Are you sure you want to leave? All provided data will be lost.";
    e.returnValue = message;
    return message;
  };

  React.useEffect(() => {
    fetchAll();
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout
      header="StaffManagePage"
      snackOpen={snackOpen}
      snackClose={() => setSnackOpen(false)}
      snackMessage={snackMessage}
      snackSeverity={snackSeverity}
      open={open}
      setOpen={setOpen}
    >
      <Title
        title={`問卷表格設定 / 修改`}
        history={() => navigate(-1)}
        children={
          <div>
            <IconButton
              component="label"
              onClick={() => {
                const temp = [...formGroup];
                temp.push({
                  type: constant.boxValue[0].type,
                  labelName: "",
                  optionValue: Array(2).fill({
                    value: "",
                    label: "",
                  }),
                });
                setFormGroup(temp);
              }}
            >
              <AddOutlined />
            </IconButton>
            <IconButton component="label" onClick={handleSubmit}>
              <SaveIcon />
            </IconButton>
          </div>
        }
      />
      <UpperForm
        {...{
          formDetail,
          setFormDetail,
          isErrorFormDetail,
          optionList,
        }}
      />
      {formGroup.map((item, index) => {
        return (
          <StyledPaper page={"yes"} key={index} alignItems={"left"}>
            <ThemeProvider theme={{}}>
              <Grid container spacing={2}>
                <Grid
                  container
                  rowGap={2}
                  alignContent={"flex-start"}
                  size={{
                    xs: 12,
                    md: 2,
                    lg: 2,
                  }}
                >
                  <FormControl
                    fullWidth
                    error={!!isErrorFormGroup[index]?.type}
                  >
                    <InputLabel id="demo-simple-select-label">類別</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={item.type}
                      label="類別"
                      onChange={(event) => {
                        const temp = { ...formGroupCopy[index] };
                        temp["type"] = event.target.value;
                        formGroupCopy[index] = temp;
                        setFormGroup(formGroupCopy);
                      }}
                    >
                      {constant.boxValue.map((item, index) => (
                        <MenuItem
                          value={item.type}
                          key={index}
                          disabled={index === 0}
                        >
                          {item.display}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText>
                      {isErrorFormGroup[index]?.type}
                    </FormHelperText>
                  </FormControl>
                  {(formGroup[index]["type"] === "dropDown" ||
                    formGroup[index]["type"] === "checkBox") && (
                    <TextField
                      value={formGroup[index]["optionValue"]["length"]}
                      onChange={(event) => {
                        const temp = { ...formGroupCopy[index] };
                        temp["optionValue"] = Array(
                          parseInt(event.target.value) || 0
                        ).fill({ label: "", value: "" });
                        formGroupCopy[index] = temp;
                        setFormGroup(formGroupCopy);
                      }}
                      helperText={`請輸入${formGroup[index]["type"]} 數量`}
                      id="demo-helper-text-aligned"
                    />
                  )}
                </Grid>
                <Grid
                  container
                  spacing={2}
                  size={{
                    xs: 12,
                    md: 10,
                    lg: 10,
                  }}
                >
                  <FormText
                    isErrorFormGroup={isErrorFormGroup}
                    parentIndex={index}
                    formGroup={formGroup}
                    type={item.type}
                    handleChange={setFormGroup}
                  />
                </Grid>
              </Grid>
            </ThemeProvider>
          </StyledPaper>
        );
      })}
    </Layout>
  );
};

export default QuestionnaireUpdatePage;

function FormText(props) {
  const isErrorFormGroup = props?.isErrorFormGroup;
  const parentIndex = props?.parentIndex;
  const formGroup = [...props?.formGroup];
  const optionValue = [...formGroup[parentIndex]["optionValue"]];
  const optionValueCopy = [...formGroup[parentIndex]["optionValue"]];

  return (
    <React.Fragment>
      <Grid
        size={{
          xs: 12,
          md: 2,
          lg: 2,
        }}
      >
        <TextField
          error={!!isErrorFormGroup[parentIndex]?.labelName}
          value={formGroup[parentIndex]["labelName"]}
          onChange={(event) => {
            formGroup[parentIndex]["labelName"] = event.target.value;
            props?.handleChange(formGroup);
          }}
          helperText={
            isErrorFormGroup[parentIndex]?.labelName
              ? isErrorFormGroup[parentIndex]?.labelName
              : "請輸入問題"
          }
          id="demo-helper-text-aligned"
        />
      </Grid>
      <Grid
        container
        spacing={2}
        size={{
          xs: 12,
          md: 9,
          lg: 9,
        }}
      >
        {(props.type === "checkBox" || props.type === "dropDown") &&
          optionValue?.map((item, index) => {
            return (
              <Grid
                key={index}
                container
                gap={2}
                size={{
                  xs: 12,
                  md: 3,
                  lg: 3,
                }}
              >
                <TextField
                  error={
                    !!isErrorFormGroup[parentIndex]?.["optionValue"][index]?.[
                      "label"
                    ]
                  }
                  value={item["label"]}
                  onChange={(event) => {
                    const temp = { ...optionValueCopy[index] };
                    temp["label"] = event.target.value;
                    temp["value"] = event.target.value;
                    optionValueCopy[index] = temp;
                    formGroup[parentIndex]["optionValue"] = optionValueCopy;
                    props?.handleChange(formGroup);
                  }}
                  helperText={
                    isErrorFormGroup[parentIndex]?.["optionValue"][index]?.[
                      "label"
                    ]
                      ? isErrorFormGroup[parentIndex]["optionValue"][index][
                          "label"
                        ]
                      : `請輸入${props.type}${index + 1} 值`
                  }
                  id="demo-helper-text-aligned"
                />
              </Grid>
            );
          })}
      </Grid>
      <Grid
        container
        justifyContent={"center"}
        alignItems={"center"}
        size={{
          xs: 1,
          md: 1,
          lg: 1,
        }}
      >
        <IconButton
          component="label"
          onClick={() => {
            formGroup.splice(parentIndex, 1);
            props?.handleChange(formGroup);
          }}
        >
          <DeleteIcon />
        </IconButton>
      </Grid>
    </React.Fragment>
  );
}
